import React from 'react';
import CurrencyDropDown from './DropDown/CurrencyDropDown';
import WeightDropDown from './DropDown/WeightDropDown';
import GoldSilverDropDown from './DropDown/GoldSilverDropDown';
import currencyOptions from '../assets/currency.json';
import Loader from './Loader';
import country from '../assets/country.json';
import weight from '../assets/weight.json';
import DaysRatiosDropDown from './DropDown/DaysRatioDropDown';
import MaterialRatiosDropDown from './DropDown/MaterialRatiosDropDown.js';
import Image from './Image';

class Midchart extends React.Component {
    // static image urls
    imgUrls = [
        {title: "ratios_chart_gold", url: "https://goldprice.org/charts/gold_3d_b_o_usd_x.png"},
        {title: "ratios_chart_silver", url: "https://goldprice.org/charts/silver_3d_b_o_usd_x.png"},
        {title: "ratios_gp_gold", url: "https://goldprice.org/charts/gold_3d_b_silver_x.png"},
        {title: "ratios_gp_silver", url: "https://goldprice.org/charts/silver_3d_b_gold_x.png"},
        {title: "ratios_chart_history_gold", url: "https://goldprice.org/charts/history/gold_10_year_o_usd_x.png"},
        {title: "ratios_chart_history_silver", url: "https://goldprice.org/charts/history/silver_20_year_o_usd_x.png"},
    ];

    //days for the dropdown of days based on the currency chosen
    day_options = [{value: '1d', name: '1 Day'},{value: '3d', name: '3 Days'},{value: '7_day', name: '7 Days'},
    {value: '30_day', name: '30 Days'},{value: '60_day', name: '60 Days'},
    {value: '6_month', name: '6 months'},{value: '1_year', name: '1 Year'},
    {value: '2_year', name: '2 Years'},{value: '5_year', name: '5 Years'},
    {value: '10_year', name: '10 Years'},{value: '15_year', name: '15 Years'},
    {value: '20_year', name: '20 Years'}, {value: '30_year', name: '30 Years'},{value: 'all_data', name: 'All Data'},];

    // declare the state
    state = {
        gold_title: ['Gold','USD'],
        silver_title: ['Silver','USD'],
        loader: true,
        weightLoader: true,
        defaultDay: '1d',
        time: '1d',
        defDay: this.props.defaultDays ? this.props.defaultDays : '3d',
        material: this.props.defaultValue,
        gs: this.props.gs ? this.props.gs : 'Gold/Silver',
    };


    //lifecycle method runs on page load
    componentDidMount = () => {
        const urls = this.imgUrls;

        //set the day options in the state
        this.setState({
            day_options: this.days_options
        })
        //change the currency default based on the country page
        if(!window.location.href.includes('gold-price-per') && !window.location.href.includes('silver-price-per')) {
           
            const fetchData = async () => {
                var defaultCurr = 'USD';
                var defaultPage = "default";
                country.filter(item => window.location.href.includes(item.view_node)).map(item => {
                    this.setState({
                        defaultCurrency: item.field_currency_symbol,
                        currency: item.field_currency_symbol,
                    })
                    defaultCurr = item.field_currency_symbol
                    defaultPage = item.field_currency_symbol
                    return null;
                })
                if(localStorage.getItem(`${this.props.title}_${defaultPage}`) &&  JSON.parse(localStorage.getItem(`${this.props.title}_${defaultPage}`)).currency !== undefined)     {
                    defaultCurr = JSON.parse(localStorage.getItem(`${this.props.title}_${defaultPage}`)).currency
                }
                urls.map((item,index) => {
                    var imgname = item.url.split('/').pop()
                    imgname = imgname.includes('USD')  ? imgname.replace('USD', defaultCurr) : imgname
                    imgname = imgname.includes('usd') ? imgname.replace('usd',defaultCurr.toLowerCase()) : imgname
                    this.setState({
                        [item.title] : imgname
                    })
                    return item.url
                })
                this.handleDefaultDayChange(defaultCurr);
                this.setState({
                    page: defaultPage,
                    loader: false,
                })
            };
            fetchData() 
        }
        else if(window.location.href.includes('gold-price-per') || window.location.href.includes('silver-price-per') ) {
            //change weight based on weight pages
            const fetchDefaultWeight = async () => {
                var defaultPage = "default";
                weight.filter(item => window.location.href.split("/").slice(-1)[0].includes(item.title.toLowerCase().replace(/ /g,"-")))
                .map(item => {
                    var weig = "o"
                    if(item.field_charts_def_gold_weight === "Kilo") {
                        weig = "k"
                    }
                    else if(item.field_charts_def_gold_weight === "Gram") {
                        weig = "g"
                    }
                    defaultPage = weig
                    urls.map((item,index) => {
                        var imgname = item.url.split('/').pop()
                        imgname = imgname.includes('_o_') ? imgname.replace('_o_', '_'+weig+'_') : imgname
                        if(imgname.includes("silver") && imgname.includes("_g_")) {
                            imgname = imgname.includes('_g_') ? imgname.replace('_g_', '_o_') : imgname
                        }
                        this.setState({
                            [item.title] : imgname
                        })
                        return null
                    })
                    this.setState({
                        weightLoader: false,
                        defaultWeight: weig,
                        page: defaultPage,
                        loader: false,
                    })
                    return null;
                })
            }
            fetchDefaultWeight();
        }
        else {
            // set image name in state
            urls.map((item,index) => {
                const imgname = item.url.split('/').pop()
                this.setState({
                    [item.title] : imgname
                })
                return item.url
            })
            this.setState({
                page: 'default',
                loader: false,
            })
        }
    }

    handleDefaultDayChange = (val) => {
        //handle day change based on currency selected
        var obj = currencyOptions.find((element) => {
            return element.code === val;
        })
        var dayOptions = [];
        var flag = true;
        if(obj) {
            let options = this.day_options
            if(options) {
                options.forEach(element => {
                    if(flag)
                        dayOptions = [...dayOptions, element]
                    if(obj.time === element.value) {
                        flag = false;
                        return;
                    }
                });
                dayOptions = [...dayOptions,options[options.length - 1]]
                this.setState({
                    day_options: dayOptions
                })
            }
        }
    }

    //handle material change
    handleMaterialChange = (val, prevValue = null) => {
        var previousValue = prevValue
        this.setState({
            material: val
        })
        const chartName = this.props.title
        let name = this.state[chartName].split('_');
        if(localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName) {
            name = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName.split("_");
        }
        let change_name = "";
        const { material = null, weight = null, currency = null, days = null } = this.getChartPropertiesFromLocalStorage();
        
        if(val === "Ratios" || material === "Ratios") {
            change_name = name
            if(val !== "Ratios") {
                const weig = weight ? weight : 'o';
                const curr = currency ? currency : 'usd';
                const day = days ? days : '3d';
                change_name[0] = val.toLowerCase();
                if(day === '3d') {
                    change_name[change_name.length - 2] = weig+"_"+curr;
                }
                else if(day === '1d') {
                    change_name[change_name.length -1] = curr.toUpperCase()+".png"
                    change_name[change_name.length -2] = weig+'_x'
                }
                else {
                    change_name[change_name.length - 2] = weig+"_"+curr
                }
                change_name = change_name.join("_");
                this.setState({
                    currency: curr,
                    weight: weig,
                })
                this.updateLocalStorage({name: 'currency', value: curr})
                this.updateLocalStorage({name: 'weight', value: weig})
            }
            else {
                if(change_name[change_name.length - 1] === "x.png") {
                    if(change_name[0] === 'gold') {
                        this.setState({
                            gs: 'Gold/Silver'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Gold/Silver' })
                        change_name[change_name.length -2] = 'silver' 
                    }
                    else if(change_name[0] === 'silver') {
                        this.setState({
                            gs: 'Silver/Gold'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Silver/Gold' })
                        change_name[change_name.length -2] = 'gold'
                    }
                    change_name.splice(-3,1)
                    change_name = change_name.join("_") 
                }
                else {
                    if(change_name[0] === 'gold') {
                        this.setState({
                            gs: 'Gold/Silver'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Gold/Silver' })
                        change_name[change_name.length -1] = 'silver.png' 
                        change_name[change_name.length -2] = 'l'
                    }
                    else if(change_name[0] === 'silver') {
                        this.setState({
                            gs: 'Silver/Gold'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Silver/Gold' })
                        change_name[change_name.length -1] = 'gold.png'
                        change_name[change_name.length -2] = 'l'
                    }
                    change_name.splice(-3,1)
                    change_name = change_name.join("_") 
                }
            }
        }
        else if(previousValue === "ratios") {
            change_name = name
            if(val !== "Ratios") {
                const weig = weight ? weight : 'o';
                const curr = currency ? currency : 'usd';
                const day = days ? days : '3d';
                change_name[0] = val.toLowerCase();
                if(day === '3d') {
                    change_name[change_name.length - 2] = weig+"_"+curr;
                }
                else if(day === '1d') {
                    change_name[change_name.length -1] = curr.toUpperCase()+".png"
                    change_name[change_name.length -2] = weig+'_x'
                }
                else {
                    change_name[change_name.length - 2] = weig+"_"+curr
                }
                change_name = change_name.join("_");
                this.setState({
                    currency: curr,
                    weight: weig,
                })
                this.updateLocalStorage({name: 'currency', value: curr})
                this.updateLocalStorage({name: 'weight', value: weig})
            }
            else {
                if(change_name[change_name.length - 1] === "x.png") {
                    if(change_name[0] === 'gold') {
                        this.setState({
                            gs: 'Gold/Silver'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Gold/Silver' })
                        change_name[change_name.length -2] = 'silver' 
                    }
                    else if(change_name[0] === 'silver') {
                        this.setState({
                            gs: 'Silver/Gold'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Silver/Gold' })
                        change_name[change_name.length -2] = 'gold'
                    }
                    change_name.splice(-3,1)
                    change_name = change_name.join("_") 
                }
                else {
                    if(change_name[0] === 'gold') {
                        this.setState({
                            gs: 'Gold/Silver'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Gold/Silver' })
                        change_name[change_name.length -1] = 'silver.png' 
                        change_name[change_name.length -2] = 'l'
                    }
                    else if(change_name[0] === 'silver') {
                        this.setState({
                            gs: 'Silver/Gold'
                        })
                        this.updateLocalStorage({ name: 'gs', value: 'Silver/Gold' })
                        change_name[change_name.length -1] = 'gold.png'
                        change_name[change_name.length -2] = 'l'
                    }
                    change_name.splice(-3,1)
                    change_name = change_name.join("_") 
                }
            }
        }
        else {
            console.log(val)
            if(chartName.includes('performance')) {
                name = this.state[chartName].split('-')
                let cur_val = 'USD';
                if(localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).currency) {
                    cur_val = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).currency
                }
                if(this.props.defaultValue === "Gold"){
                    let gold_title = [...this.state.gold_title];
                    gold_title[0] = val 
                    gold_title[1] = cur_val
                    this.setState({
                        gold_title
                    })
                }
                else if(this.props.defaultValue === "Silver") {
                    let silver_title = [...this.state.silver_title];
                    silver_title[0] = val
                    silver_title[1] = cur_val
                    this.setState({
                        silver_title
                    })
                }
            }
            if(this.state[chartName].includes("high_o")) {
                name = this.state[chartName].split("_")
            }
            change_name = name.map(item => {
                return item === previousValue ? val.toLowerCase() : item
            })
            if(change_name[0] === 'silver') {
                change_name = change_name.map(item => {
                    return item === 'g' ? 'o' : item
                })
            }
            if(this.state[chartName].includes("high_o")) {
                change_name = change_name.join("_")
            }
            else if(chartName.includes('performance'))
                change_name = change_name.join("-")
            else if(val === "Silver") {
                change_name[0] = "silver";
                change_name = change_name.join("_")
            }
            else if(val === "Gold") {
                change_name[0] = "gold";
                change_name = change_name.join("_")
            }
            else {
                change_name = change_name.join("_")
            }
            this.setState({
                [chartName]: change_name,
                material: val
            })
            if(val === "Silver" && localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).weight === 'g') {
                this.updateLocalStorage({ name: 'weight', value: 'o' })
            } 
        }
        if(change_name.includes("_g_") && val === "Silver") {
            change_name = change_name.replace("_g_","_o_");
            this.setState({
                [chartName]: change_name
            })
            this.updateLocalStorage({name: 'weight', value: 'o'})
        }
        this.updateLocalStorage({ name: 'material', value: val })
        this.updateLocalStorage({ name: 'chartName', value: change_name });
    }

    //handle currency change 
    handleCurrencyChange = (val, prevValue) => {
        var previousValue = prevValue.toLowerCase();
        const chartName = this.props.title
        let currency = this.state[chartName];
        if(localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName) {
            currency = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName;
        }
        if(currency.toLowerCase().includes(previousValue)) {
            if(currency.includes('1d') || currency.includes('performance') || currency.includes("high_o") ) {
                currency = currency.replace(previousValue.toUpperCase(),val)
            }
            else {
                currency = currency.replace(previousValue.toLowerCase(),val.toLowerCase())
                currency = currency.replace(previousValue.toUpperCase(),val.toLowerCase())
            }
    
            //handle day change based on currency selected
            var obj = currencyOptions.find((element) => {
                return element.code === val;
            })
            var dayOptions = [];
            var flag = true;

            if(obj) {
                var options = this.day_options;
                options.map(element => {
                    if(flag)
                        dayOptions = [...dayOptions, element]
                    if(obj.time === element.value)
                        flag = false
                    return null
                })

                //set the all data as the last element
                dayOptions = [...dayOptions,options[options.length - 1]]

                this.setState({
                    day_options: dayOptions
                })
            }
            this.setState({
                [chartName]: currency,
                currency: val,
                defaultCurrency: val,
            })
    
            this.updateLocalStorage({ name: 'currency', value: val })
            this.updateLocalStorage({ name: 'chartName', value: currency });
            if(obj) {

                var all_data = dayOptions.filter(e => e.value === this.state.time)
                var time = this.state.time
                if(JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).days) {
                    all_data = dayOptions.filter(e => e.value === JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).days)
                    time = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).days
                }
                
                if(all_data.length === 0) {
                    this.setState({
                        time: "all_data"
                    })
                    this.handleRatioDayChange('all_data', time)
                    this.updateLocalStorage({name: 'days', value: 'all_data'})
                    return ;
                }
            }
        }
    }

    //handle weight change
    handleWeightChange = (val, prevValue = null) => {
        var previousValue = prevValue.toLowerCase();
        const chartName = this.props.title
        let weight = this.state[chartName].split('_');
        if(localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName) {
            weight = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName.split("_");
        }
        let change_weight = weight.map( item => {
            return item === previousValue ? val : item
        })
        change_weight = change_weight.join("_")
        this.setState({
            [chartName]: change_weight,
            defaultWeight: val
        })
        this.updateLocalStorage({ name: 'weight', value: val })
        this.updateLocalStorage({ name: 'chartName', value: change_weight });
    }

    ratioDayGPChange = (val, prevValue = null) => {
        var previousValue = prevValue.toLowerCase();
        const chartName = this.props.title;
        let day = this.state[chartName]
        if(localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName) {
            day = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName;
        }
        if(previousValue === '1d' && val === '3d') {
            day = day.replace('1d_b_l', '3d_b')
        }
        else if(previousValue === '3d' && val === '1d') {
            day = day.replace('3d_b', '1d_b_l')
            day = day.replace('_x.','.')
        }
        else if(previousValue === '1d') {
            day = day.replace('1d_b_l',val)
            day = day.replace('.','_x.')
        }
        else if(previousValue === '3d') {
            day = day.replace('3d_b',val)
            // day = day.replace('.','_x.')
        }
        else if((previousValue !== '1d' || previousValue !== '3d')&&(val !== '1d' && val !== '3d')) {
            day = day.replace(previousValue, val)
        }
        else if(val === '1d') {
            day = day.replace(previousValue, '1d_b_l')
            day = day.replace('_x.','.')
        }
        else if(val === '3d') {
            day = day.replace(previousValue, '3d_b')
            day = day.replace('_x.','.')
        }
        this.setState({
            [chartName]: day
        })
        this.updateLocalStorage({name: 'days', value: val})
        this.updateLocalStorage({name: 'chartName', value: day})
    }

    handleRatioDayChange = (val, prevValue = null) => {
        var previousValue = prevValue.toLowerCase()
        const chartName = this.props.title
        const { material = null } = this.getChartPropertiesFromLocalStorage();

        if(this.state.material === "Ratios" || material === "Ratios") {
            this.ratioDayGPChange(val, previousValue)
            return;
        }
        else {
            let day = this.state[chartName]
            if(localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName) {
                day = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName;
            }
            if(day.includes(previousValue)) {
                day = day.replace(previousValue, val).split("_")
                day = day.reverse()
                if(val !== '1d') {
                    if(previousValue === '1d')
                        day[1] = day[0].toLowerCase().substring(0,3);
                    day[0] = 'x.png'
                }
                else if(val === '1d') {
                    day[0] = day[1].toUpperCase()+".png";
                    day[1] = 'x'
                }
    
                day = day.reverse().join("_")
                if((val === '1d' || val === '3d')&& !day.includes("b")) {
                    day = day.replace(val,val+"_b")
                }
                else if(val !== '1d')   
                    day = day.replace("b_","")
                if(day.includes("3d") && previousValue === '1d') {
                    day = day.replace("3d","3d_b")
                }
            }
            if(day.includes("3d") && !day.includes("3d_b")) {
                day = day.replace("3d", "3d_b");
            }
            this.setState({
                [chartName]: day,
                defDay: val
            })
            this.updateLocalStorage({name: 'days', value: val})
            this.updateLocalStorage({name: 'chartName', value: day})
        }
    }

    handleMaterialRatioChange = (val, prevValue = null) => {
        var previousValue = prevValue ? prevValue.toLowerCase() : 'gold/silver';
        const chartName = this.props.title
        let material = this.state[chartName].split("_")
        if(localStorage.getItem(`${chartName}_${this.state.page}`) &&  JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName) {
            material = JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName.split("_");
        }
        const last_element = material.length - 1
        if(previousValue === "gold/silver") {
            material[0] = 'silver'
            if(material[last_element] === 'x.png') {
                material[last_element-1] = 'gold'
            }
            else {
                material[last_element] = 'gold.png'
            }
        }
        else if(previousValue === "silver/gold") {
            material[0] = 'gold'
            if(material[last_element] === 'x.png') {
                material[last_element-1] = 'silver'
            }
            else {
                material[last_element] = 'silver.png'
            }
        }
        else if(val === "Ratio") {
            if(this.state.day == null){
                material=material.join('_').replace("1d_b_o_x_USD","1d_b_l_silver").split("_");
            }
            else if(this.state.day === '1d') {
                material=material.join('_').replace("day_","").split("_");
                material=material.join('_').replace("year_","").split("_");
                material=material.join('_').replace("month_","").split("_");
                material=material.join('_').replace("_x","").split("_");
                material[1] = "1d_b_l"; 
            }
            else if(this.state.day === '3d') {
                material=material.join('_').replace("year_","").split("_");
                material=material.join('_').replace("month_","").split("_");
                material=material.join('_').replace("day_","").split("_");
                material=material.join('_').replace("_x","").split("_");
                material[1] = "3d_b"
            }
            else if(this.state.day !== '1d') {
                if(this.state.day !== '3d') {
                    material[last_element] = material[last_element].replace(".","_x.");
                    material=material.join('_').replace("1d_b_l",this.state.day).split("_");
                }
                else if(this.state.day === "3d") {
                    material=material.join('_').replace("1d_b_l","3d_b").split("_");
                }
            }
        }
        
        material = material.join("_")

        this.setState({
            [chartName]: material,
        })
        this.updateLocalStorage({ name: 'gs', value: val })
        this.updateLocalStorage({ name: 'chartName', value: material });
    }

    //set and update the local storage
    updateLocalStorage = (payload) => {
        let chartType = `${this.props.title}`;
        const { name = "", value= "" } = payload;

        let existingValue = localStorage.getItem(`${chartType}_${this.state.page}`) ? JSON.parse(localStorage.getItem(`${chartType}_${this.state.page}`)) : {};
        let updatedValues = { ...existingValue, [name]: value };
        localStorage.setItem(`${chartType}_${this.state.page}`, JSON.stringify(updatedValues));
    }

    //get the local storage values
    getChartPropertiesFromLocalStorage = () =>{
        return localStorage.getItem(`${this.props.title}_${this.state.page}`) ? JSON.parse(localStorage.getItem(`${this.props.title}_${this.state.page}`)) : {};
    }

    //get the latest chart urls title
    getLatestChartUrlFromLocalStorage = () =>{
        var { title  : chartName = "" } = this.props;
        if(this.state.ratios) {
            chartName = "ratios_gp_gold"
        }
        return localStorage.getItem(`${chartName}_${this.state.page}`) ? JSON.parse(localStorage.getItem(`${chartName}_${this.state.page}`)).chartName : this.state[chartName];
    }

    render() {
        const { material = null, currency = null, weight = null, days = null, gs = null } = this.getChartPropertiesFromLocalStorage();
        const chartURL = this.getLatestChartUrlFromLocalStorage();
        const hostname = window.location.hostname;
        let redirect_link = '#'
        if(hostname.includes('silverprice.org')) {
            redirect_link = '/spot-silver.html'
        }
        else if(hostname.includes('goldprice.org')) {
            redirect_link = '/spot-gold.html'
        }
        const baseUrl = 'https://goldprice.org/charts/';
        return (
            <div>
            {!this.state.loader ?
                <section className="current-price">
                    <div className='hidden jmb_local_code'>
                        {this.state.page}
                    </div>
                        <div className="performance-table text-center image-loader">
                            {/* calling the image */}
                            <Image height = "420px" chartUrl = {chartURL} title = {this.props.title} />
                        </div>
                        <div className="select-wrapper silver-performance-chart">
                            <form className="text-center">
                                {/* material DropDown filter */}
                                {this.props.material === "nomaterial" ? null : 
                                <MaterialRatiosDropDown chart_name = {this.props.title} defaultValue = {material ? material : this.props.defaultValue} title = {this.props.title} handleChange = {this.handleMaterialChange} /> }
                                {/* Gold Silver dropdown filter  */}
                                {(this.state.material === "Ratios" && !material) || material === "Ratios" ? 
                                <GoldSilverDropDown dafaultGS = {gs ? gs : this.state.gs} handleChange = {this.handleMaterialRatioChange} /> : null}
                                {/* currency DropDown filter */}
                                {(this.state.material === "Ratios" && !material) || material === "Ratios" ? null :
                                <CurrencyDropDown defaultCurrency = {currency ? currency : this.state.defaultCurrency} handleChange = {this.handleCurrencyChange} /> }
                                {/* weight DropDown filter */}
                                {(this.state.material === "Ratios" && !material) || material === "Ratios" ? null :
                                <WeightDropDown material = {material ? material : null} defaultWeight = {weight ? weight : this.state.defaultWeight} url = {material ? material : this.props.defaultValue} handleChange = {this.handleWeightChange} /> }
                                {/* day DropDown filter */}
                                {this.props.title.includes("ratios")
                                ? <DaysRatiosDropDown chart_name = {this.props.title} options = {this.state.day_options} value = {days ? days : this.state.defDay} threeDay = "true" url = {material ? material : this.props.defaultValue} handleChange = {this.handleRatioDayChange} /> : null}
                            </form>
                        </div>
                </section> : <Loader />}
            </div>
        );
    }
}

export default Midchart;